import WidgetMessagePreview from 'components/MessagePreview'
import WidgetIcon from 'components/WidgetIcon'
import useLanguageSwitcher from 'hooks/useLanguageSwitcher'
import React from 'react'
import { LiveAnnouncer } from 'react-aria-live'

const ControllerLayout = () => {
  useLanguageSwitcher()

  return (
    <main role="main" aria-label="Widget Icon">
      <LiveAnnouncer>
        <WidgetMessagePreview/>
        <WidgetIcon/>
      </LiveAnnouncer>
    </main>
  )
}

export default ControllerLayout
